// import _ from "lodash";
import { onMounted, onBeforeUnmount, reactive, watch, ref } from "vue";
// api
// import { getArticleList } from "@/api/common";
import { getPointRacesListApi } from "@/api/home-page";
// hooks
import usePagination from "@/hooks/common/pagination";
// config
import { championshipPC, raceRoundPC } from "@/config/homePage";

export function useHomePage() {
  onMounted(() => {
    resetScrFct();
  });

  onBeforeUnmount(() => {});
  const homePageState = reactive({
    code: "",
    isNone: false,
    raceQuarterShow: {},
    groupShow: {},
    raceShow: {},
    raceQuartertype: 11, // 赛季季度类型
    groupType: 3, // 组别类型
    raceType: getCurrentRaceType(11), // 比赛类型-冠军/淘汰/积分
  });

  // 监听组别类型切换
  watch(
    () => homePageState.groupType,
    () => {
      setInterval(resetScrFct('select'), 1000);
    }
  );

  // 监听赛季类型切换
  watch(
    () => homePageState.raceType,
    () => {
      setInterval(resetScrFct('select'), 1000);
    }
  );

  function getCurrentRaceType(race) {
    let current = new Date().getTime();
    console.log('race', race)
    let raceType = 1;
    // 淘汰赛、冠军赛
    if (
      raceRoundPC[race][0].date < current &&
      championshipPC[race][0].startDate > current
    ) {
      raceType = 2;
    } else if (championshipPC[race][0].startDate < current) {
      raceType = 3;
    } else {
      raceType = 1;
    }
    console.log('raceType', raceType)
    return raceType;
  }

  function resetScrFct(edit) {
    if (homePageState.raceType === 1) {
      // raceTpyeReqApi();
      if (edit === 'select' && integPage.currentPage !== 1) {
        // console.log('切换分组，当前页不为第一页')
        integPage.currentPage = 1
        resetScrFct()
      } else {
        getPointRacesList();
      }
      // getPointRacesList();
      const integRefTime = setInterval(function () {
        try {
          const integDom = document.getElementById("integRef") || null
          integDom && integDom.addEventListener("scroll", handleScroll);
        } catch (error) {
          console.log('error', error);
          clearTimeout(integRefTime);
        }
        // 时间间隔
      }, 1000);
    }
    integrationState.integrationList = [];
    integrationState.integratLoading = false;
    integrationState.isLastPage = false;
    integrationState.pageCount = 1;
  }

  /**
   * 公共模块
   */

  // function raceTpyeReqApi() {
  //     if (homePageState.raceType === 1) {
  //         // 积分赛类型
  //         getPointRacesList();
  //     }
  // }

  // 赛季季度切换
  function raceQuarterSwitchFct(val) {
    homePageState.raceQuartertype = val.value;
    // 如果是2025赛季，默认选中冠军赛，否则默认选中积分赛
    if (val.value === 2025) {
      homePageState.raceType = 3; // 冠军赛
    } else {
      homePageState.raceType = 1; // 积分赛
    }
    // 切换赛季重置信息
    homePageState.groupType = 1;
    // 避免沿用上一赛季无数据态，导致冠军赛组件不渲染
    homePageState.isNone = false;
    // 取新的赛程信息
    if (homePageState.raceType === 1) {
      resetScrFct('select');
    }
  }

  // 组别类型切换
  function groupSwitchFct(val) {
    homePageState.groupType = val.value;
  }

  // 赛季类型切换
  function raceTypeSwitchFct(val) {
    homePageState.isNone = false;
    homePageState.raceType = val.value;
    resetScrFct('select');
  }

  /**
   * 积分赛模块
   */
  const integrationState = reactive({
    integrationList: [], // 积分赛数据
    integratLoading: false,
    isLastPage: false, // 是否是最后一页
    pageCount: 1,
  });
  const integRef = ref(null);

  const { paginationState: integPage } = usePagination({
    currentPage: 1,
    pageSize: 20,
    onChange: () => {},
  });

  function handleScroll() {
    const integScrollEle = document.getElementById("integRef");
    // 滚动元素的真实高度
    const clientH = integScrollEle.clientHeight;
    // 滚动元素可见区域高度
    const scrollH = integScrollEle.scrollHeight;
    // 滚动距离-滚动条顶部到浏览器顶部高度
    const scrollTopH = integScrollEle.scrollTop;
    // 距离底部50
    const currentH = clientH + scrollTopH + 50;

    // 等待上一次请求加载完成
    if (integrationState.integratLoading) {
      return;
    }

    // 判断是否触底加载
    if (currentH >= scrollH) {
      if (integrationState.isLastPage) {
        return;
      }
      getPointRacesList(true);
    }
  }

  // 获取积分赛列表
  function getPointRacesList(isNext) {
    integrationState.integratLoading = true;
    if (isNext) {
      // 判断当前页码大于总页码
      integPage.currentPage =
        integPage.currentPage >= integrationState.pageCount
          ? integrationState.pageCount
          : ++integPage.currentPage;
    }
    const params = {
      matchSeason: homePageState.raceQuartertype,
      matchGroup: homePageState.groupType,
      page: integPage.currentPage,
      pageRows: integPage.pageSize,
    };
    getPointRacesListApi(params)
      .then((res) => {
        const data = res.data;
        if (res.data.list.length === 0) {
          homePageState.isNone = true;
        } else {
          homePageState.isNone = false;
        }
        integrationState.integratLoading = false;
        // 判断是否触底加载，拼接数据
        if (isNext && integPage.currentPage !== 1) {
          integrationState.integrationList =
            integrationState.integrationList.concat(data.list);
        } else {
          integrationState.integrationList = data.list || [];
        }

        integrationState.total = data.total || 0;
        // 计算总页码数
        integrationState.pageCount = Math.ceil(data.total / integPage.pageSize);

        // 判断是否是最后一页
        integrationState.isLastPage =
          integPage.currentPage >= integrationState.pageCount;
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  return {
    homePageState,
    raceQuarterSwitchFct,
    groupSwitchFct,
    raceTypeSwitchFct,
    // 积分赛模块
    integrationState,
    integRef,
  };
}
